import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Button,
} from "@mui/material";
import { COLORS, fontFamilyAll } from "../assets/commonComponents/COLORS";

const cardStyles = {
  position: "relative",
  background: "rgba(255, 255, 255, 0.15)",
  backdropFilter: "blur(14px)",
  borderRadius: "18px",
  boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
  overflow: "hidden",
  transition: "all 0.35s ease-in-out",
  "&:hover": {
    transform: "translateY(-8px) scale(1.02)",
    boxShadow: "0 14px 28px rgba(0,0,0,0.25)",
  },
};

const imageOverlay = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.5))",
  opacity: 0,
  transition: "opacity 0.3s ease-in-out",
  "&:hover": {
    opacity: 1,
  },
};

export default function ServiceCard({ isMobile, data, headingText, subHeadingText }) {
  return (
    <Box sx={{ px: { xs: 2, sm: 4, md: 8 }, py: { xs: 3, sm: 6 } }}>
      {/* Heading */}
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign="center"
        mb={1}
        sx={{
          color: COLORS.primaryColor,
          fontFamily: fontFamilyAll,
          fontSize: { xs: "1.8rem", sm: "2rem", md: "2.2rem" },
        }}
      >
        {headingText}
      </Typography>

      {/* Subheading */}
      <Typography
        variant="h6"
        textAlign="center"
        mb={{ xs: 3, sm: 5 }}
        sx={{
          color: COLORS.blackColor,
          fontFamily: fontFamilyAll,
          fontSize: { xs: "1.1rem", sm: "1.25rem" },
          fontWeight: 500,
        }}
      >
        {subHeadingText}
      </Typography>

      {/* Service Cards */}
      <Grid container spacing={4} justifyContent="center">
        {data.map((item, index) => (
          <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
            <Card sx={cardStyles}>
              <CardActionArea>
                {/* Image */}
                {item.image && (
                  <Box sx={{ position: "relative" }}>
                    <CardMedia
                      component="img"
                      height="220"
                      image={item.image}
                      alt={item.title}
                      sx={{ objectFit: "cover" }}
                    />
                    <Box sx={imageOverlay}></Box>
                  </Box>
                )}

                {/* Content */}
                <CardContent sx={{ textAlign: "center", p: 3 }}>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{
                      color: COLORS.secondary,
                      fontFamily: fontFamilyAll,
                      mb: 1,
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      lineHeight: 1.6,
                      fontFamily: fontFamilyAll,
                      textAlign: "justify",
                      mb: 2,
                    }}
                  >
                    {item.description}
                  </Typography>

                  {/* CTA Button */}
                  <Button
                    variant="contained"
                    size="small"
                    fontFamily={fontFamilyAll}
                    sx={{
                      background: COLORS.primaryColor,
                      color: "#fff",
                      borderRadius: "20px",
                      textTransform: "none",
                      px: 3,
                      "&:hover": {
                        background: COLORS.secondary,
                      },
                    }}
                  >
                    Learn More
                  </Button>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
